import { Link } from 'react-router-dom';

const otherOffers = [
  {
    icon: 'bi-shield-check',
    title: 'Audit de sécurité gratuit',
    text: "Une analyse complète de votre environnement informatique pour identifier les failles avant qu'elles ne deviennent un problème.",
    tag: 'Nouveau client',
  },
  {
    icon: 'bi-cloud-arrow-up',
    title: 'Migration Microsoft 365 accompagnée',
    text: "Passage à Microsoft 365 ou Azure pris en charge de A à Z, avec formation de vos équipes incluse.",
    tag: 'Cloud',
  },
  {
    icon: 'bi-headset',
    title: 'Forfait support illimité',
    text: 'Surveillance proactive et support technique à volonté pour un tarif mensuel fixe, sans surprise.',
    tag: 'PME',
  },
];

export default function Offres() {
  return (
    <>
      <section className="hero-section section pb-0">
        <div className="hero-blob"></div>
        <div className="container position-relative text-center" data-aos="fade-up">
          <span className="eyebrow">Offres en cours</span>
          <h1 className="fw-900 mt-3 display-5">Des solutions, et un coup de pouce pour démarrer</h1>
          <p className="lead text-secondary mx-auto" style={{ maxWidth: '680px' }}>
            Quelques promotions actuelles pour simplifier le passage à une technologie plus
            moderne — à commencer par notre offre vedette en téléphonie IP.
          </p>
        </div>
      </section>

      {/* OFFRE VEDETTE — TÉLÉPHONIE IP */}
      <section className="section">
        <div className="container">
          <div className="offer-card offer-featured p-4 p-md-5" data-aos="zoom-in">
            <div className="row align-items-center gy-4">
              <div className="col-lg-7">
                <span className="offer-ribbon badge-pulse">Offre vedette · Téléphonie IP</span>
                <h2 className="fw-900 mt-3">Migration gratuite + 1 mois offert</h2>
                <p className="text-secondary mt-3">
                  Passez à la téléphonie IP sans frais de démarrage : analyse de vos besoins,
                  configuration de vos postes, transfert de vos numéros actuels et formation
                  de vos équipes — tout est inclus. En plus, le premier mois d'abonnement est
                  offert.
                </p>
                <ul className="list-unstyled d-flex flex-column gap-2 mt-3">
                  <li><i className="bi bi-check-circle-fill text-brand me-2"></i>Aucuns frais de migration ou de configuration</li>
                  <li><i className="bi bi-check-circle-fill text-brand me-2"></i>Vos numéros actuels conservés, sans interruption</li>
                  <li><i className="bi bi-check-circle-fill text-brand me-2"></i>Premier mois d'abonnement offert</li>
                  <li><i className="bi bi-check-circle-fill text-brand me-2"></i>Application mobile et de bureau incluses</li>
                </ul>
                <div className="d-flex flex-wrap gap-3 mt-4">
                  <Link to="/contact" className="btn btn-brand btn-lg rounded-pill px-4">
                    Profiter de l'offre
                  </Link>
                  <Link to="/telephonie-ip" className="btn btn-outline-brand btn-lg rounded-pill px-4">
                    En savoir plus sur la téléphonie IP
                  </Link>
                </div>
                <p className="font-mono small text-secondary mt-3 mb-0">
                  OFFRE DE LANCEMENT &middot; NOMBRE DE PLACES LIMITÉ &middot; CONDITIONS SUR DEMANDE
                </p>
              </div>
              <div className="col-lg-5 text-center">
                <div className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
                     style={{ width: '8rem', height: '8rem', background: 'var(--cpuc-red-soft)' }}>
                  <i className="bi bi-telephone-fill text-brand" style={{ fontSize: '3rem' }}></i>
                </div>
                <h3 className="fw-900 display-6 mb-0">1<span className="text-brand">er</span> mois</h3>
                <p className="text-secondary mb-0">offert sur votre forfait téléphonie IP</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* AUTRES OFFRES */}
      <section className="section pt-0">
        <div className="container">
          <span className="eyebrow" data-aos="fade-up">Aussi en ce moment</span>
          <h2 className="fw-900 mt-3 mb-4" data-aos="fade-up">D'autres façons de simplifier votre informatique</h2>

          <div className="row g-4">
            {otherOffers.map((o, i) => (
              <div className="col-md-4" key={o.title} data-aos="fade-up" data-aos-delay={i * 100}>
                <div className="offer-card p-4 h-100">
                  <div className="d-flex justify-content-between align-items-start mb-3">
                    <div className="service-icon">
                      <i className={`bi ${o.icon}`}></i>
                    </div>
                    <span className="news-tag">{o.tag}</span>
                  </div>
                  <h3 className="h5 fw-bold">{o.title}</h3>
                  <p className="text-secondary small">{o.text}</p>
                  <Link to="/contact" className="fw-bold text-decoration-none">
                    En profiter <i className="bi bi-arrow-right ms-1"></i>
                  </Link>
                </div>
              </div>
            ))}
          </div>

          <p className="text-secondary small mt-4 mb-0">
            * Offres présentées à titre indicatif — remplacez ce texte par vos promotions
            réelles et leurs conditions.
          </p>
        </div>
      </section>
    </>
  );
}
